module.exports = __webpack_public_path__ + "img/youtube.d1362e76.svg";